module.exports = __webpack_public_path__ + "img/草豆蔻.36cd0e39.jpg";